import * as yup from 'yup';

const schemaAuth = yup.object().shape({
  email: yup
    .string()
    .email('Informe um email válido. Ex: exemplo@exemplo.com')
    .required('Informe o email'),
  password: yup
    .string()
    .min(6, 'A senha deve ter no mínimo 6 dígitos')
    .required('Informe a senha'),
});

export default schemaAuth;
